import { render, staticRenderFns } from "./base-column.vue?vue&type=template&id=1b983acc&scoped=true&"
import script from "./base-column.vue?vue&type=script&lang=js&"
export * from "./base-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b983acc",
  null
  
)

export default component.exports